import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { LIFECYCLE_LOOP_NOTE } from '../../domain/safetyCases/safetyCasesWorkspacePresentationCopy';

/** Frozen product lifecycle steps (not tab labels). Attention is the work queue, not a step. */
export const WORKSPACE_LIFECYCLE_STEPS = [
  'Safety Case',
  'Safety Scan',
  'Review & Sign',
  'Signed Record',
  'Control',
  'Follow-up Scan',
] as const;

export const WORKSPACE_LIFECYCLE_LOOP_NOTE = LIFECYCLE_LOOP_NOTE;

/**
 * Compact product-story rail for Safety Management.
 * Separate from working-view tabs (Attention / Safety Cases / Safety Scans / Signed Records).
 */
export function WorkspaceLifecycleRail() {
  return (
    <Box sx={{ mb: 0.5 }} aria-label="Product lifecycle">
      <Stack
        data-testid="workspace-lifecycle-rail"
        direction="row"
        flexWrap="wrap"
        useFlexGap
        alignItems="center"
        columnGap={0.5}
        rowGap={0.25}
        sx={{ lineHeight: 1.2 }}
      >
        {WORKSPACE_LIFECYCLE_STEPS.map((step, index) => (
          <React.Fragment key={step}>
            {index > 0 ? (
              <Typography
                component="span"
                variant="caption"
                color="text.disabled"
                aria-hidden
                sx={{ fontSize: '0.6875rem', userSelect: 'none' }}
              >
                {' → '}
              </Typography>
            ) : null}
            <Typography
              component="span"
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.01em' }}
            >
              {step}
            </Typography>
          </React.Fragment>
        ))}
      </Stack>
      <Typography
        variant="caption"
        color="text.disabled"
        data-testid="workspace-lifecycle-loop-note"
        sx={{ display: 'block', mt: 0.15, fontSize: '0.65rem', lineHeight: 1.2, fontStyle: 'italic' }}
      >
        {WORKSPACE_LIFECYCLE_LOOP_NOTE}
      </Typography>
    </Box>
  );
}
